module.exports = __webpack_public_path__ + "static/media/vegas-6.3ad510be.jpg";